
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const budgetService = {
    budgetList,
    budgetDetails,
    getBBudgetmasterData,
    submitBudget,
    deleteBudget,
    budgetVsActual,
    budgetBalanceSheet


};

//========= PAYMENT MADE SERVICE  =============== 
async function  budgetList() {
    return apiClient.get(`/payment/budget-list`, authHeader());
}


async function  submitBudget(formData) {
    return apiClient.post(`/payment/submit-budget`,formData, authHeader());
}

async function  getBBudgetmasterData() {
    return apiClient.get(`/payment/budget-master-data`, authHeader());
}


async function  budgetDetails(budgetId) {
    return apiClient.get(`/payment/budget-details/${budgetId}`, authHeader());
}


async function  budgetBalanceSheet(tillDate) {
    return apiClient.get(`/payment/budget-balance-sheet/${tillDate}`, authHeader());
}


async function  budgetVsActual(budgetId) {
    return apiClient.get(`/payment/budget-vs-actual/${budgetId}`, authHeader());
}


async function  deleteBudget(budgetId) {
    return apiClient.delete(`/payment/delete-budget/${budgetId}`, authHeader());
}




















